import HNSColors from "../../../../ui library/HNSColors";

export const STYLES = {
  menuDropdownButtonStyle: {
    border: "1px solid",
    backgroundColor: HNSColors.neutrals[900],
    color: HNSColors.secondary[500],
    borderColor: HNSColors.secondary[500],
    "&:hover": {
      backgroundColor: HNSColors.secondary[900],
      color: HNSColors.secondary[500],
      borderColor: HNSColors.neutrals[900],
    },
  },
  menuItemStyle: {
    "&:hover": {
      backgroundColor: HNSColors.tertiary[900],
      color: HNSColors.primary[500],
    },
    "&.Mui-selected": {
      backgroundColor: HNSColors.tertiary[900],
      color: HNSColors.primary[500],
    },
    "&.Mui-selected:hover": {
      backgroundColor: HNSColors.tertiary[900],
    },
  },

  menuListStyle: {
    width: "342px",
    border: "1px solid",
    borderRadius: "8px",
    borderColor: HNSColors.secondary[500],
    boxShadow: "none",
    marginTop: "2px",
  },

  addButtonStyle: {
    border: "1px solid",
    backgroundColor: HNSColors.neutrals[900],
    borderColor: HNSColors.secondary[500],
    color: HNSColors.secondary[500],
    fontWeight: "400",
    "&:hover": {
      backgroundColor: HNSColors.secondary[900],
      color: HNSColors.secondary[400],
      fontWeight: "600",
    },
  },
  dateTimePicker: {
    textField: {
      "& .MuiOutlinedInput-root": {
        padding: 0,
        borderRadius: "8px",
        transition: "border-color 0.3s",
        color: HNSColors.neutrals[500],
        "& fieldset": {
          borderColor: HNSColors.neutrals[400],
        },
        "&.Mui-focused fieldset": {
          border: `1.5px solid ${HNSColors.secondary[500]}`,
        },
        "& .MuiInputBase-input": {
          padding: "15px",
        },
        "& .MuiInputBase-input textarea": {
          padding: "15px",
        },
        "& .MuiSelect-icon": {
          color: HNSColors.primary[500],
        },
      },
    },
    openPickerButton: {
      marginRight: "10px",
    },
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      padding: "0",
      borderRadius: "8px",
      transition: "border-color 0.3s",
      "& fieldset": {
        borderColor: HNSColors.neutrals[400],
      },
      "&.Mui-focused fieldset": {
        border: `1.5px solid ${HNSColors.secondary[500]}`,
      },
      "& .MuiInputBase-input": {
        padding: "8px",
      },
      "& .MuiInputBase-input textarea": {
        padding: "1.5px",
      },
      "& .MuiSelect-icon": {
        color: HNSColors.primary[500],
      },
    },
  },
  selectMenuPaper: {
    marginTop: 1,
    borderRadius: "8px",
    backgroundColor: "#FFFFFF",
    color: HNSColors.neutrals[100],
    border: `1.5px solid ${HNSColors.secondary[500]}`,
    "& .MuiList-root": {
      padding: 0,
    },
  },

  container: {
    backgroundColor: HNSColors.tertiary[950],
    borderRadius: "14px",
  },
  headerName: {
    fontSize: 20,
    fontWeight: 600,
    color: HNSColors.neutrals[100],
  },
  headerLocation: {
    fontSize: 16,
    color: HNSColors.neutrals[500],
  },
  headerStatusBadge: {
    borderRadius: "300px",
  },
};
